/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_UpdatedInputs */

const en_cargo_updated = /** @type {(inputs: Cargo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargo updated`)
};

const es_cargo_updated = /** @type {(inputs: Cargo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga actualizada`)
};

/**
* | output |
* | --- |
* | "Cargo updated" |
*
* @param {Cargo_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_updated = /** @type {((inputs?: Cargo_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_updated(inputs)
	return es_cargo_updated(inputs)
});